import { render, staticRenderFns } from "./presaledetail.vue?vue&type=template&id=3c7c99e0&"
import script from "./presaledetail.vue?vue&type=script&lang=js&"
export * from "./presaledetail.vue?vue&type=script&lang=js&"
import style0 from "./presaledetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports